// src/config.ts
const production = true;

export const config = {
  // --- Connection Configs --- //
  production,
  apiUrl: production
    ? "https://api-rastreamentodepedido.tegrapharma.com"
    : "http://localhost:3333",

  // --- System Configs --- //
  appName: `TegraPharma Corp Tracking`,
  appAgent: `tegrapharmatx`,

  // --- Contact Area --- //
  contact: {
    whatsapp: 11995987696,
  },
};
